import { defineComponent } from 'vue';
import { QInput, QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const CALENDAR_PICKER_CHANGE_CODE_BEHIND = {
    handlerSuffix: '_Change',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your change handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'calendar-picker-dsgn',
    mixins: [BaseComponentMixin],
    components: { QInput, QIcon },
    computed: {
        containerStyle() {
            return {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                paddingTop: '3px',
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                ...utils.getStyleHints(this.controlData?.StyleHints, this),
                minWidth: '280px',
            };
        },
    },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, CALENDAR_PICKER_CHANGE_CODE_BEHIND);
        },
    },
    render() {
        if (!this.controlData)
            return null;

        return (
            <div
                class={{ 'c-CalendarPicker': true, 'designer-container': true, selected: this.selected$ }}
                style={this.containerStyle}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                <QInput
                    outlined
                    dense
                    readonly
                    label="Select Date Range"
                    modelValue=""
                >
                    {{
                        append: () => <QIcon name="mdi-calendar" />,
                    }}
                </QInput>
            </div>
        );
    },
});
